'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var useRadioGroup = require('../RadioGroup/useRadioGroup.js');
var RadioIcon = require('./RadioIcon.js');
var Radio_module = require('./Radio.module.scss.js');

var Radio = React.forwardRef(function (_a, ref) {
    var valueProp = _a.value, inputProps = _tslib.__rest(_a, ["value"]);
    var inputRef = React.useRef(null);
    var radioGroup = useRadioGroup["default"]();
    if (radioGroup === undefined) {
        throw new Error('Radios must be wrapped in a Radio Group.');
    }
    var name = radioGroup.name, onChange = radioGroup.onChange, value = radioGroup.value;
    var checked = valueProp === value;
    React.useImperativeHandle(ref, function () { return ({
        focus: function () {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        },
    }); });
    return (jsxRuntime.jsxs("span", _tslib.__assign({ className: Radio_module["default"].radio }, { children: [jsxRuntime.jsx("input", _tslib.__assign({ checked: checked, className: Radio_module["default"].radioInput, name: name, onChange: onChange, type: "radio", ref: inputRef, value: valueProp }, inputProps)), checked ? jsxRuntime.jsx(RadioIcon["default"], { checked: true }) : jsxRuntime.jsx(RadioIcon["default"], {})] })));
});

exports["default"] = Radio;
//# sourceMappingURL=Radio.js.map
